
<template>
  <div class="text-xs-center">
    <v-dialog v-model="resetDialog" persistent max-width="300">
      <v-card>
        <v-card-title class="headline ">Reset Values?</v-card-title>
        <v-card-text>Are you sure you want to reset the values to their defaults? This will overwrite any values you have specified.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="resetDialog = false">No</v-btn>
          <v-btn color="green darken-1" flat @click.native="resetToDefaults">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="show"
      persistent
      width="70%"
      height="80%"
    >
      <v-card>
        <v-card-title
          class="headline"
          primary-title
        >
          Cost Comparison Detail
        </v-card-title>
  
        <v-card-text class="grey lighten-3">
          <v-container>
            <v-layout column style="height: 60vh">
              <v-flex xs12 style="overflow: auto" class="ccd-table-wrapper">
                <v-data-table
                    :headers="headers"
                    :items="data"
                    hide-actions
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <td :class="props.item.class || ''">{{ props.item.name }}</td>
                      <td 
                        v-for="(m, idx) in markets" v-bind:key="`market:${idx}`" 
                        :class="getValueItemClass(props.item)"
                      >
                        <v-edit-dialog
                          v-if="props.item.dataKey != undefined"
                          __return-value.sync=""
                          large
                          lazy
                        >
                          <div v-show="props.item.dataKey != undefined" class="table-value">{{ marketParamValue(idx, props.item.dataKey, true) }}</div>
                          <!-- <div v-show="props.item.data[idx]" class="table-value">{{ props.item.data[idx] }}</div> -->

                          <div slot="input" class="mt-3 dialog-title text-xs-center">{{ props.item.name }}</div>
                          <v-text-field
                            slot="input"
                            :value="marketParamValue(idx, props.item.dataKey, false)"
                            label="Edit"
                            single-line
                            autofocus
                            v-on:change="setMarketParamValue(idx, props.item.dataKey, $event)"
                          ></v-text-field>                          
                        </v-edit-dialog>
                      </td>
                    </template>
                  </v-data-table>        
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>


        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="resetDialog = true"
          >
            Reset To Default
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click="didCancel()"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click="didApply()"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'cost-comparison-detail',
  data () {
    return {
      internalMarketParams: { },
      resetDialog: false,
      data: [
        { value: false, class: 'parent-row', name: 'Real Estate' },
        { value: false, class: 'child-row', name: 'Building SF', dataKey: 'buildingSqft' },
        { value: false, class: 'child-row', name: 'Annual Lease Per Square Foot', dataKey: 'rentPerSqftAnnual' },
        { value: false, class: 'child-row', name: 'Annual Operating Expense Per Square Foot', dataKey: 'annualOperatingExpensesPerSqft' },
        { value: false, class: 'sub-parent-row', name: 'Advanced' },
        { value: false, class: 'sub-child-row', name: 'Any Additional Total Lease Expenses', dataKey: 'annualOperatingExpenses' },
        { value: false, class: 'sub-child-row', name: 'Total Tenant Improvement Allowance', dataKey: 'tenantImprovementAllowance' },
        { value: false, class: 'sub-child-row', name: 'Discount Rate %', dataKey: 'leaseDiscountRate' },
        { value: false, class: 'sub-child-row', name: 'Total Startup Cost', dataKey: 'startupCost' },

        { value: false, class: 'parent-row', name: 'Inbound Transportation Cost' },
        { value: false, class: 'child-row', name: 'Containers Per Year',  dataKey: 'containersPerYear' },
        { value: false, class: 'child-row', name: 'Cost Per Container', dataKey: 'costPerContainer' },
        { value: false, class: 'sub-parent-row', name: 'Advanced' },
        { value: false, class: 'sub-child-row', name: 'Fuel Surcharge', dataKey: 'fuelSurcharge' },
        { value: false, class: 'sub-child-row', name: 'Additional Freight Costs', dataKey: 'additionalFreightCosts' },
        { value: false, class: 'sub-child-row', name: 'Air Freight Cost', dataKey: 'airFreightCost' },

        { value: false, class: 'parent-row', name: 'Outbound Logistics Cost' },
        { value: false, class: 'child-row', name: 'Outbound Logistics Cost', dataKey: 'outboundLogisticsCost' },

        { value: false, class: 'parent-row', name: 'Labor' },
        { value: false, class: 'child-row', name: 'Full Time Warehouse Employees', dataKey: 'numberFullTimeEmployees' },
        { value: false, class: 'child-row', name: 'Full Time Hourly Wage', dataKey: 'fullTimeHourlyWage' },
        { value: false, class: 'child-row', name: 'Full Time Hours / Week', dataKey: 'fullTimeHoursPerWeek' },
        { value: false, class: 'child-row', name: 'Weeks Per Year', dataKey: 'fullTimeWeeksPerYear' },
        { value: false, class: 'sub-parent-row', name: 'Advanced' },
        { value: false, class: 'sub-child-row', name: 'Temporary Warehouse Employees', dataKey: 'numberTempEmployees' },
        { value: false, class: 'sub-child-row', name: 'Temporary Employees Hourly Wage', dataKey: 'tempHourlyWage' },
        { value: false, class: 'sub-child-row', name: 'Temporary Employees Hourly / Week', dataKey: 'tempHoursPerWeek' },
        { value: false, class: 'sub-child-row', name: 'Supervisor Employees', dataKey: 'numberSupervisorEmployees' },
        { value: false, class: 'sub-child-row', name: 'Supervisor Salary', dataKey: 'supervisorSalary' },
        { value: false, class: 'sub-child-row', name: 'Admin Employees', dataKey: 'numberAdminEmployees' },
        { value: false, class: 'sub-child-row', name: 'Admin Salary', dataKey: 'adminSalary' },
        { value: false, class: 'sub-child-row', name: 'Benefits %', dataKey: 'benefits' },
        { value: false, class: 'sub-child-row', name: 'Workers Compensation %', dataKey: 'workersCompensationPercentage' },
        { value: false, class: 'sub-child-row', name: 'Total Replacement Cost Per Employee', dataKey: 'replacementCost' },
        { value: false, class: 'sub-sub-child-row', name: 'Attrition Rate %', dataKey: 'attritionRate' }
      ]
    }
  },

  props: [ 
    'show',
    'markets',
    'marketParams'
  ],

  beforeMount: function() {
    this.internalMarketParams = _.cloneDeep(this.marketParams)
  },
  watch: {
    show: function() {
      if(this.show){
        this.internalMarketParams = _.cloneDeep(this.marketParams)
      }
    },
    marketParams: function() {
      this.internalMarketParams = _.cloneDeep(this.marketParams)
    },
    totalSqft: function(v) {
      _.keys(this.internalMarketParams).forEach(o => {
        this.internalMarketParams[o].buildingSqft.default = this.internalMarketParams[o].buildingSqft.current = v.val
      })

      this.updateMarketParams()
    },
    headCountPerWarehouse: function(v) {
      _.keys(this.internalMarketParams).forEach(o => {
        this.internalMarketParams[o].numberWarehouseEmployees.default = this.internalMarketParams[o].numberWarehouseEmployees.current = v.val
      })

      this.updateMarketParams()
    },
    containersPerYear: function(v) {
      _.keys(this.internalMarketParams).forEach(o => {
        this.internalMarketParams[o].containersPerYear.default = this.internalMarketParams[o].containersPerYear.current = v.val
      })

      this.updateMarketParams()
    }
  },  

  methods: {
    didCancel() {
      this.internalMarketParams = _.cloneDeep(this.marketParams)
      this.$emit('did-cancel')      
    },
    didApply() {
      this.$emit('did-apply', this.internalMarketParams)      
    }, 
    resetToDefaults() {
      _.keys(this.internalMarketParams).forEach(k => {
        _.values(_.omit(this.internalMarketParams[k], 'marketId')).forEach(s => {
          s.current = s.default
        })
      }) 
      
      this.resetDialog = false
    },
    getValueItemClass(item) {
      return `${item.class}-val`
    },
    marketParamsForIndex(idx) {
      let marketId = this.markets[idx].market.id
      return this.internalMarketParams[marketId]
    },
    marketParamValue(idx, name, formatted) {      
      let param = this.marketParamsForIndex(idx)
      if(param) return formatted ? param[name].formatter(param[name].current) : param[name].current
      else return 0
     },
    setMarketParamValue(idx, name, v) {
      let marketId = this.markets[idx].market.id
      let s = String(v).replace('/,/g', '').replace('/$/g', '').replace('/%/g', '')
      this.internalMarketParams[marketId][name].current = Number(s) || 0
      // if custom market, set the new value as default as well
      if(marketId.indexOf("0_") == 0){
        this.internalMarketParams[marketId][name].default = Number(s) || 0
      }
    }
  },

  computed: {
    marketsToCompare() {
      return this.$store.getters.marketsToCompare
    },
    headers() {
      let h = [{ text: '',align: 'left', sortable: false, value: 'name' }]

      let marketHeaders = this.markets.map((o) => {          
        return {
          text: o.market.name, align: 'left', sortable: false, value: o.market.name
        }
      })

      return h.concat(marketHeaders)
    }
  },

  components: {
  }
}

</script>


<style scoped>
.parent-row {
  font-weight: bold;
  font-size:11pt;
  border-top: 5px double lightgrey;
  border-bottom: 5px double lightgrey;
}
.parent-row-val {
  font-weight: bold;
  font-size:11pt;
  border-top: 5px double lightgrey;
  border-bottom: 5px double lightgrey;
  text-align: center;
}
.child-row {
  font-size:10pt;
  padding-left: 50px;
}
.child-row-val {
  text-align: center;
}
.sub-parent-row {
  font-size:10pt;
  font-style: italic;
}
.sub-parent-row-val {
  text-align: center;
}
.sub-child-row-val {
  text-align: center;
}
.sub-child-row {
  font-size:10pt;
  text-indent: 3ch;
}
.sub-sub-child-row-val {
  text-align: center;
}
.sub-sub-child-row {
  font-size:10pt;
  text-indent: 6ch;
}
.table-value {
  font-size: 12pt;
  font-weight: bold;
  color: #004B8A;
  position: relative;
}
.dialog-title {
  font-weight:bold;
  font-size:11pt;
}
</style>
<style>
.ccd-table-wrapper .elevation-1 > div {
  overflow: initial;
}
</style>